{
	"cashflow": {
		"demonstrative": "Declaración",
		"expensses": "Gastos/Ingresos",
		"extract": "Extracto",
		"history": "Historial",
		"title": "Financiero"
	},
	"competence": "Competencia",
	"dueDate": "Fecha de vencimiento",
	"expenses": {
		"perAnything": "Pagado a...",
		"perCategory": "Por categoría",
		"perCostCenter": "Por centro de coste",
		"perDay": "Por día",
		"perDescripion": "Por descripción",
		"perHistory": "Historial",
		"perType": "Por tipo",
		"title": "GASTOS"
	},
	"receipts": {
		"perAnything": "Recibido de...",
		"perCategory": "Por categoría",
		"perCostCenter": "Por centro de coste",
		"perDay": "Por día",
		"perDescripion": "Por descripción",
		"perHistory": "Historial",
		"perType": "Por tipo",
		"title": "RECIBOS"
	}
}
